module.exports = __webpack_public_path__ + "encs/web_store/avpv/img/folder-phone.8e174a80.svg";